import { render, staticRenderFns } from "./MyCalendar.vue?vue&type=template&id=09d5476c&scoped=true"
import script from "./MyCalendar.vue?vue&type=script&lang=ts"
export * from "./MyCalendar.vue?vue&type=script&lang=ts"
import style0 from "./MyCalendar.vue?vue&type=style&index=0&id=09d5476c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d5476c",
  null
  
)

export default component.exports